// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O78O","footer":"styles_footer__30Mz9"};